mutation RemoveEditableDerestriction($campaignId: ID!, $editableId: ID!) {
    removeEditableDerestriction(editableId: $editableId, campaignId: $campaignId) {
        _id
        name
        restricted
    }
}
